import { config } from '@uhg-abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import REPORT_INACCURATE_PROVIDER from './ReportInaccurateProvider.graphql';

export const useReportInaccurateProvider = (options) => {
  const [queryResults, queryAction] = useCustomQuery(
    REPORT_INACCURATE_PROVIDER,
    {
      ...options,
      url: config('GRAPHQL_API_URL'),
      accessor: 'reportInaccurateProvider',
      onCompleted: (result) => {
        if (options?.handleSuccess) {
          options?.handleSuccess();
        }
        return result;
      },
      onError: (error) => {
        if (options?.handleError) {
          options?.handleError();
        }
        throw error;
      },
    }
  );

  return [queryResults, queryAction];
};
